<template>
  <div class="report-filters card mb-3">
    <div class="card-body py-3">
      <div class="row align-items-end">
        <div class="col-md-3 col-sm-6 mb-2">
          <label class="filter-label">Գնումների պլան</label>
          <select v-model="filters.procurement_id" class="form-control form-control-sm" @change="emit">
            <option value="">Բոլորը</option>
            <option v-for="p in procurements" :key="p.id" :value="p.id">
              {{ p.name }} ({{ p.year }})
            </option>
          </select>
        </div>

        <div class="col-md-2 col-sm-6 mb-2">
          <label class="filter-label">Գնման ձև</label>
          <select v-model="filters.cpv_type" class="form-control form-control-sm" @change="emit">
            <option value="">Բոլորը</option>
            <option value="1">Ապրանք</option>
            <option value="2">Ծառայություն</option>
            <option value="3">Աշխատանք</option>
          </select>
        </div>

        <div class="col-md-2 col-sm-6 mb-2">
          <label class="filter-label">Ստորաբաժանում</label>
          <select v-model="filters.classifier" class="form-control form-control-sm" @change="emit">
            <option value="">Բոլորը</option>
            <option v-for="c in classifiers" :key="c" :value="c">{{ c }}</option>
          </select>
        </div>

        <div class="col-md-2 col-sm-6 mb-2">
          <label class="filter-label">Կարգավիճակ</label>
          <select v-model="filters.status" class="form-control form-control-sm" @change="emit">
            <option value="">Բոլորը</option>
            <option value="0">Ակտիվ</option>
            <option value="1">Հաստատված</option>
            <option value="2">Խմբ. հաստ.</option>
          </select>
        </div>

        <div class="col-md-3 col-sm-6 mb-2">
          <label class="filter-label">Որոնում (CPV / անվ.)</label>
          <input
            v-model="filters.query"
            type="text"
            class="form-control form-control-sm"
            placeholder="CPV կամ անվանում..."
            @input="onSearch"
          />
        </div>
        <div class="col-md-2 col-sm-6 mb-2">
          <label class="filter-label">Մatakarar</label>
          <input v-model="filters.supplier" type="text" class="form-control form-control-sm" placeholder="Мatakarar anuv..." @input="onSearch" />
        </div>
      </div>

      <div class="row align-items-end mt-1">
        <div class="col-md-3 col-sm-6 mb-2">
          <label class="filter-label">Ամսաթիվ (սկիզբ)</label>
          <input v-model="filters.date_from" type="date" class="form-control form-control-sm" @change="emit" />
        </div>
        <div class="col-md-3 col-sm-6 mb-2">
          <label class="filter-label">Ամսաթիվ (վերջ)</label>
          <input v-model="filters.date_to" type="date" class="form-control form-control-sm" @change="emit" />
        </div>
        <div class="col-auto mb-2 ml-auto">
          <button @click="reset" class="btn btn-sm btn-outline-secondary mr-2">
            <i class="mdi mdi-refresh"></i> Մաքրել
          </button>
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportFilters',
  props: {
    value: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      procurements: [],
      classifiers: [],
      searchTimer: null,
      filters: {
        procurement_id: '',
        cpv_type: '',
        classifier: '',
        status: '',
        query: '',
        supplier: '',
        date_from: '',
        date_to: '',
        ...this.value,
      },
    }
  },
  async mounted() {
    await Promise.all([this.loadProcurements(), this.loadClassifiers()])
  },
  methods: {
    async loadProcurements() {
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/procurements')
        this.procurements = data.data
      } catch (e) { /* silent */ }
    },
    async loadClassifiers() {
      try {
        const params = this.filters.procurement_id ? { procurement_id: this.filters.procurement_id } : {}
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/classifiers', { params })
        this.classifiers = data.data
      } catch (e) { /* silent */ }
    },
    onSearch() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => this.emit(), 400)
    },
    emit() {
      if (this.filters.procurement_id) this.loadClassifiers()
      this.$emit('filter', { ...this.filters })
    },
    reset() {
      this.filters = { procurement_id: '', cpv_type: '', classifier: '', status: '', query: '', supplier: '', date_from: '', date_to: '' }
      this.$emit('filter', { ...this.filters })
    },
  },
}
</script>

<style scoped>
.filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 3px;
  display: block;
}
</style>
